// DishTech React
import {actions as reduxActions, actionTypes as reduxActionTypes} from '@dishtech-react/redux';

// Action Types
import {actionTypes} from '../action-types';

const {registerForm, setFieldValue, setFieldValues} = reduxActions;

const handleAddShelf = (dispatch, {folder: {mode}, form}, {shelf}) => {
  const formKey = `${mode.toUpperCase()}_STOREFRONT`;
  const {
    [formKey]: {
      values: {shelves = []},
    },
  } = form;

  return dispatch(setFieldValue(formKey, 'shelves', [...shelves.filter(({id}) => id !== shelf.id), shelf]));
};

const handleRemoveShelf = (dispatch, {shelfId}, {folder: {mode}, form}) => {
  const formKey = `${mode.toUpperCase()}_STOREFRONT`;
  const {
    [formKey]: {
      values: {shelves = []},
    },
  } = form;

  return dispatch(
    setFieldValue(
      formKey,
      'shelves',
      shelves.filter(shelf => shelfId !== shelf.id)
    )
  );
};

const openOverlay = (dispatch, mode) => {
  dispatch({
    payload: {
      mode,
    },
    type: actionTypes.STOREFRONT_SET_MODE,
  });
  dispatch({
    payload: {
      overlayId: `storefront_${mode}`,
    },
    type: reduxActionTypes.OVERLAY_OPEN,
  });
};

const handleUpdateStorefront = (dispatch, {storefrontData}) => {
  Promise.resolve(dispatch(registerForm('UPDATE_STOREFRONT'))).then(() =>
    Promise.resolve(dispatch(setFieldValues('UPDATE_STOREFRONT', storefrontData))).then(() => {
      openOverlay(dispatch, 'update');
    })
  );
};

const handleCreateStorefront = dispatch => {
  openOverlay(dispatch, 'create');
};

export const storefrontMiddleware = store => next => action => {
  const {dispatch, getState} = store;

  next(action);

  const nextState = getState();

  const actions = {
    [actionTypes.STOREFRONT_ADD_SHELF]: () => handleAddShelf(dispatch, action.payload, nextState),
    [actionTypes.STOREFRONT_CREATE]: () => handleCreateStorefront(dispatch, action.payload, nextState),
    [actionTypes.STOREFRONT_REMOVE_SHELF]: () => handleRemoveShelf(dispatch, action.payload, nextState),
    [actionTypes.STOREFRONT_UPDATE]: () => handleUpdateStorefront(dispatch, action.payload),
  };

  if (actions[action.type]) {
    return actions[action.type]();
  }
};
